import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated } from '../helpers/userHelper';

const PublicOnlyRoute = ({ user, redirectTo = '/', ...props }) => {
  if (isAuthenticated(user)) {
    return <Redirect to={redirectTo} />;
  }

  return <Route {...props} />;
};

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
  };
};

export default connect(mapStateToProps)(PublicOnlyRoute);
